module.exports = "https://static.wanderu.com/ui-react/_next/static/media/google-badge.86d7c822.png";